// features/counter/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const targetIsDpoSlice = createSlice({
  name: "targetIsDpo",
  initialState,
  reducers: {
    getTargetIsDpo: (state, action) => {
      // console.log("realtimeCamera payload:", action.payload);
      state.data = action.payload;
    },
    clearTargetIsDpo: (state) => {
      // console.log('masuk')
      state.data = [];
    },
  },
});

export const { getTargetIsDpo, clearTargetIsDpo } = targetIsDpoSlice.actions;
export default targetIsDpoSlice.reducer;
